import React, { useEffect } from 'react';
import { CONFIG } from '../../../config';
import './AmazonAddressWidget.scss';

type Props = {
  onReady?: (billingAgreementId: string) => void;
  onError?: () => void;
};

type OrderReference = {
  getAmazonBillingAgreementId: () => string;
};

const CONTAINER_ID = 'amazonAddressWidget';

const renderWidget = (onReady?: Props['onReady'], onError?: Props['onError']) => {
  new window.OffAmazonPayments.Widgets.AddressBook({
    sellerId: CONFIG.AMAZON_SELLER_ID,
    agreementType: 'BillingAgreement',
    onReady: (orderReference: OrderReference) =>
      onReady?.(orderReference.getAmazonBillingAgreementId()),
    onError: () => onError?.(),
    design: {
      designMode: 'responsive'
    }
  }).bind(CONTAINER_ID);
};

export const AmazonAddressWidget: React.FC<Props> = ({ onReady, onError }) => {
  useEffect(() => {
    renderWidget(onReady, onError);
  }, [onReady, onError]);

  return <div id={CONTAINER_ID} className="AmazonAddressWidget" />;
};
